/*LIBRARY*/
import { Map } from "maplibre-gl";
import { connect } from "react-redux";
import { useEffect } from "react";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "maplibre-gl-draw/dist/mapbox-gl-draw.css";

/*COMPONENT*/

/*REDUX*/
import { set_value_insight } from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/
const basemap_url = process.env.REACT_APP_MAPID_BASEMAP;
const basemap_key = process.env.REACT_APP_BASEMAP_KEY;

const SS_EXPLAINER = ({ auth, layer, insight_reducer, set_value_insight }) => {
  // //local storage
  // const language = localStorage?.language || auth.language;

  // //global props
  // const {
  //   top_result_limit,
  //   features_centroid_sample,
  //   provinsi,
  //   kota,
  //   kecamatan,
  //   kelurahan,
  // } = insight_reducer;
  // const { geo_layer_list, layer_id, feature_key_selected } = layer;
  // const geo_layer = geo_layer_list.find(
  //   (item) => item?.geo_layer?._id === layer_id
  // )?.geo_layer;
  // const features = geo_layer?.geojson?.features || [];

  useEffect(() => {
    const map_object_ss = new Map({
      container: "map_object_ss",
      style: `${basemap_url}/styles/street-2d-building/style.json?key=${basemap_key}`,
      center: [118.72762419354456, -0.2055368192132505],
      zoom: 3.7,
      maxPitch: 85,
      attributionControl: false,
      canvasContextAttributes: { antialias: true },
    });

    map_object_ss.addControl(
      new maplibregl.AttributionControl({
        customAttribution: `GEO V ${auth.version}`,
        compact: true,
      }),
      "bottom-left"
    );

    map_object_ss.addControl(
      new maplibregl.ScaleControl({
        maxWidth: 100,
        unit: "metric",
      }),
      "bottom-right"
    );

    set_value_insight({
      key: "map_object_ss",
      value: map_object_ss,
    });

    return () => {
      set_value_insight({ key: "map_object_ss", value: null });
      if (map_object_ss) {
        map_object_ss.remove();
      }
    };
  }, [auth.version, set_value_insight]);

  return (
    <main
      className="two_container_equal"
      style={{ height: "calc( 100vh - 170px )" }}
    >
      <section>Explainer</section>
      <section>
        <main
          id="map_object_ss"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  set_value_insight,
})(SS_EXPLAINER);
